import React, { useState, useEffect } from "react";
import icon from "../../assets/images/PurpleLogoIcon.svg";
// import BannerImage from '../assets/images/BannerImage.svg';
import BannerImage from "../../assets/images/BannerImage.svg";
import { Link } from "react-router-dom";

const Hero = () => {
  const [windowWidth, setWindowWidth] = useState(null);
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    if (firstRender) {
      setWindowWidth(window.innerWidth);
      setFirstRender(false);
    }
  }, []);
  return (
    <section className="tw-py-7">
  <div className="tw-mx-7 lg:tw-mx-10 xl:tw-mx-14 2xl:tw-mx-32">
    <div className="tw-flex max-lg:tw-flex-col-reverse max-lg:tw-gap-10 tw-items-center tw-justify-center lg:tw-justify-between">
      <div className="lg:tw-w-[624px] min-[1080px]:tw-w-3/5">
        <img
          className="max-lg:tw-hidden tw-w-[122px] 2xl:tw-w-44 ProductSansRegular"
          src={icon}
          alt=""
          srcset=""
        />
        <div className="lg:tw-ps-7 2xl:tw-ps-12">
          <div className="ProductSansBold lg:tw-border-l-2 tw-border-[#5d3393] xs:tw-ps-5 2xl:tw-ps-7">
            <h1 className="tw-text-[40px] tw-text-[#062533] ProductSansBlack tw-leading-[1]">
              BOOSTING YOUR BUSINESS
            </h1>
            <h2 className="tw-text-[28px] tw-text-[#5d3393] tw-leading-[1.1] tw-mt-2">
              THROUGH REAL-TIME INSIGHTS FOR
              {windowWidth > 539 && <br />} DIGITAL EVOLUTION
            </h2>
          </div>
          <div className="xs:tw-ps-4 2xl:tw-ps-7">
            <p className="tw-py-5 tw-text-[#4D4D50] tw-tracking-wider tw-leading-[1.25] ProductSansMedium tw-max-w-[629px]">
              Finanzz ERP streamlines the task of managing your financial
              records, alleviating your workload. It also simplifies your
              day-to-day activities, reducing the need for extensive manpower
              and operational costs. Access customized reports to stay informed
              about your daily transactions, ensuring you're always up-to-date.
            </p>
            <div className="tw-flex tw-flex-wrap tw-gap-4 tw-mt-2 2xl:tw-mt-5 max-lg:tw-justify-center">
              <a href="#requestdemo" className="tw-text-sm max-lg:tw-w-56 tw-px-14 tw-py-4 ProductSansBold tw-tracking-wide tw-rounded-md tw-bg-[#FDD60E] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] focus:tw-outline-none">
                REQUEST DEMO
              </a>
              <Link to="/signup" className="tw-text-sm max-lg:tw-w-56 tw-px-14 tw-py-4 ProductSansBold tw-tracking-wide tw-rounded-md tw-bg-[#5d3393] tw-shadow-[4.8px_9.6px_9.6px_rgba(0,0,0,0.25)] tw-text-white focus:tw-outline-none">
                SIGNUP FREE
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="tw-w-full lg:tw-w-[calc(100%-624px)] min-[1080px]:tw-w-2/5 xl:tw-max-w-[531px]">
        <img className="tw-w-full" src={BannerImage} alt="" srcset="" />
      </div>
    </div>
  </div>
</section>

  );
};

export default Hero;
